export const styles = (theme) => {
    return {
        content: {
            minWidth: '550px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            marginTop: '35px'
        },
        smallcontent: {
            textAlign: 'center' as 'center',
            },
        actions: {
            justifyContent: 'center',
            padding: '35px'
        }
    }
}